import instance from '@/utils/instance';

// 会话列表
export function getConversationsList(params) {
	return instance({
		url: `/webZ_api/tgtai/chat/list_conversations?user_id=${params.user_id}&page_num=${params.pageNum}&page_size=${params.pageSize}`,
		method: 'post'
	});
}

// 创建会话
export function createNewConversations(chat_type, user_id) {
	return instance({
		url: `/webZ_api/tgtai/chat/new_conversation`,
		method: 'post',
		data: {
			chat_type: chat_type,
			name: '新会话',
			user_id: user_id
		}
	});
}

// 重命名会话
export function renameConversation(conversation_id, new_name) {
	return instance({
		url: `/webZ_api/tgtai/chat/rename_conversation`,
		method: 'post',
		data: {
			conversation_id: conversation_id,
			new_name: new_name
		}
	});
}

// 删除会话
export function deleteConversation(conversation_id) {
	return instance({
		url: `/webZ_api/tgtai/chat/delete_conversation?conversation_id=${conversation_id}`,
		method: 'post'
	});
}

// 清空会话
export function clearConversation(conversation_id) {
	return instance({
		url: `/webZ_api/tgtai/chat/clear_conversation?conversation_id=${conversation_id}`,
		method: 'post'
	});
}

// 获取历史对话详情列表
export function listMsg(conversation_id) {
	return instance({
		url: `/webZ_api/tgtai/chat/list_msg?conversation_id=${conversation_id}`,
		method: 'post'
	});
}

//提交反馈
export function feedback(data) {
	return instance({
		url: `/webZ_api/tgtai/chat/feedback`,
		method: 'post',
		data
	});
}

//置顶
export function topConversation(data) {
	return instance({
		url: `/webZ_api/tgtai/chat/top_conversations`,
		method: 'post',
		data
	});
}

//知识库对话 SSE
export function kbChat(params) {
	return instance({
		url: `/webZ_api/tgtai/chat/kb_chat_rag?query=${params.query}&user_id=${params.user_id}&conversation_id=${params.conversation_id}`,
		method: 'get'
	});
}

//知识库对话 SSE - 自动模式
export function kbChatAuto(params) {
	return instance({
		url: `/webZ_api/tgtai/chat/kb_chat_auto?query=${params.query}&user_id=${params.user_id}&conversation_id=${params.conversation_id}`,
		method: 'get'
	});
}

//查询AI次数
export function getAiCount() {
	return instance({
		url: `/webL_api/consumer/member/aiCount`,
		method: 'get'
	});
}

//停止当前任务
export function postStopTask(data) {
	return instance({
		url: `/webZ_api/tgtai/chat/stop_task`,
		method: 'post',
		data
	});
}

//书单明细(结构化)
export function getFilesDocmentFindBookJsonList(data) {
	return instance({
		url: `/webL_api/consumer/member/book/queryJson`,
		method: 'post',
		data
	});
}
